import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useQuickActionShortcuts } from '../../../utils/keyboardShortcuts';
import api from '../../../utils/api';

const QuickActions = () => {
  const navigate = useNavigate();
  
  // Initialize keyboard shortcuts
  useQuickActionShortcuts();

  const quickActions = [
    {
      id: 'add-product',
      title: 'Add Product',
      description: 'Add new item to inventory',
      icon: 'Plus',
      color: 'bg-primary text-primary-foreground',
      shortcut: 'Ctrl+N',
      action: () => navigate('/product-catalog', { state: { openAddModal: true } })
    },
    {
      id: 'generate-report',
      title: 'Generate Report',
      description: 'Create inventory reports',
      icon: 'FileText',
      color: 'bg-secondary text-secondary-foreground',
      shortcut: 'Ctrl+R',
      action: () => navigate('/reports', { 
        state: { 
          openReportBuilder: true,
          reportType: 'inventory'
        } 
      })
    },
    
   
  ];

  return (
    <div className="bg-card border border-border rounded-lg shadow-card overflow-hidden">
      <div className="p-6 border-b border-border bg-gradient-to-r from-background to-muted/30">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-lg font-semibold text-foreground flex items-center">
              <Icon name="Zap" className="mr-2 text-primary" size={18} />
              Quick Actions
            </h2>
            <p className="text-sm text-muted-foreground">Frequently used operations</p>
          </div>
          <div className="flex items-center space-x-2">
            <Button 
              variant="outline" 
              size="sm" 
              iconName="RefreshCw" 
              iconPosition="left" 
              iconSize={16}
              onClick={() => window.location.reload()}
              className="hover:bg-primary/10 hover:text-primary transition-all"
            >
              Refresh
            </Button>
          </div>
        </div>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {quickActions?.map((action) => (
            <button
              key={action?.id}
              onClick={action?.action}
              className="group p-5 rounded-xl border border-border hover:border-primary/50 transition-all duration-200 hover:shadow-lg text-left relative overflow-hidden bg-card hover:bg-gradient-to-br hover:from-background hover:to-muted/20"
            >
              <div className="flex items-start space-x-4">
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${action?.color} group-hover:scale-110 transition-transform shadow-sm`}>
                  <Icon name={action?.icon} size={22} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="font-medium text-foreground group-hover:text-primary transition-hover text-base">
                      {action?.title}
                    </h3>
                    {action?.shortcut && (
                      <span className="text-xs bg-muted px-2 py-1 rounded-md text-muted-foreground font-mono shadow-sm">
                        {action?.shortcut}
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-muted-foreground">
                    {action?.description}
                  </p>
                </div>
              </div>
              <div className="absolute inset-0 bg-primary/5 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"></div>
              <div className="absolute bottom-2 right-2 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <Icon name="ArrowRight" size={16} className="text-primary" />
              </div>
            </button>
          ))}
        </div>
      </div>
      {/* <div className="p-6 border-t border-border bg-gradient-to-r from-muted/30 to-background">
        <div className="flex items-center space-x-2 mb-3">
          <div className="bg-primary/10 p-1.5 rounded-md">
            <Icon name="Keyboard" size={16} className="text-primary" />
          </div>
          <span className="text-sm font-medium text-foreground">Keyboard Shortcuts:</span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 text-sm text-muted-foreground">
          <div className="flex items-center space-x-2 bg-muted/20 p-2 rounded-lg hover:bg-muted/40 transition-colors">
            <kbd className="px-2 py-1 bg-background border border-border rounded-md text-xs font-mono shadow-sm min-w-[60px] text-center">Ctrl+N</kbd>
            <span>New product</span>
          </div>

          <div className="flex items-center space-x-2 bg-muted/20 p-2 rounded-lg hover:bg-muted/40 transition-colors">
            <kbd className="px-2 py-1 bg-background border border-border rounded-md text-xs font-mono shadow-sm min-w-[60px] text-center">Ctrl+S</kbd>
            <span>Stock adjustment</span>
          </div>
          <div className="flex items-center space-x-2 bg-muted/20 p-2 rounded-lg hover:bg-muted/40 transition-colors">
            <kbd className="px-2 py-1 bg-background border border-border rounded-md text-xs font-mono shadow-sm min-w-[60px] text-center">Ctrl+R</kbd>
            <span>Generate report</span>
          </div>
          <div className="flex items-center space-x-2 bg-muted/20 p-2 rounded-lg hover:bg-muted/40 transition-colors">
            <kbd className="px-2 py-1 bg-background border border-border rounded-md text-xs font-mono shadow-sm min-w-[60px] text-center">Ctrl+B</kbd>
            <span>Scan barcode</span>
          </div>
          <div className="flex items-center space-x-2 bg-muted/20 p-2 rounded-lg hover:bg-muted/40 transition-colors">
            <kbd className="px-2 py-1 bg-background border border-border rounded-md text-xs font-mono shadow-sm min-w-[60px] text-center">Ctrl+I</kbd>
            <span>Inventory audit</span>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default QuickActions;